import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UwActionLogHistoryComponent } from './uw-action-log-history.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SharedModule } from '@uw/shared/shared.module';

@NgModule({
    imports: [CommonModule, MatExpansionModule, MatPaginatorModule, TranslateModule, SharedModule, UwActionLogHistoryComponent],
    exports: [UwActionLogHistoryComponent],
})
export class UwActionLogHistoryModule {}
